/* eslint-disable @typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars,radix */

import { shareReplay } from 'rxjs/operators';
import { EVENTS } from '../../../../app/constants/events';
import { loadSelectPickerItems } from '../../../../app/common/store/select-picker.actions';
import { queryParamsMap } from '../../../../app/common/components/forms/select-picker/select-picker-types.enum';

xplenty.directive('jobForm', [
  '$rootScope',
  '$stateParams',
  '$timeout',
  '$window',
  '$state',
  '$translate',
  '$sce',
  'Job',
  'Cluster',
  'Package',
  'notify',
  'selectPickerModal',
  'ngrxStoreService',

  function (
    $rootScope,
    $stateParams,
    $timeout,
    $window,
    $state,
    $translate,
    $sce,
    Job,
    Cluster,
    Package,
    notify,
    selectPickerModal,
    ngrxStoreService,
  ) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../../views/directives/forms/job-form.html'),

      replace: true,

      scope: {
        job: '=ngModel',
      },

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$state',

        function ($scope, $state) {
          $scope.cluster = null;
          $scope.variables = {};
          $scope.variablesToSet = {};
          $scope.packageLoaded = false;
          $scope.variablesValid = 1;

          $scope.cluster_id = $scope.job.cluster_id;
          $scope.package_id = $scope.job.package_id;
          $scope.package = $scope.job && $scope.job.id ? $scope.job : null;

          $scope.onCreateNewCluster = ({ connection, type }) => {
            selectPickerModal.createNew(connection, type, 'cluster-picker-job-form2');

            const subscriber = $rootScope.$on(EVENTS.CLUSTER_CREATED, (event, cluster) => {
              ngrxStoreService.dispatch(
                loadSelectPickerItems({
                  id: 'cluster-picker-job-form2',
                  itemType: type,
                  params: queryParamsMap[type],
                  ignoreLoadingFlag: true,
                }),
              );
              $scope.onClusterChange(cluster);
              subscriber();
            });
          };

          const getStep = function () {
            return {
              title: '',
              activeTitle: '',
              tags: [],
              active: false,
              valid: false,
              lock: false,
              disable: false,
            };
          };

          $scope.clusterStep = getStep();
          $scope.packageStep = getStep();
          $scope.packageVariablesStep = getStep();

          $timeout(function () {
            $scope.packageVariablesStep.valid = false;
          });

          $translate([
            'job-form.steps.cluster',
            'job-form.steps.cluster-edit',
            'job-form.steps.package',
            'job-form.steps.package-edit',
            'job-form.steps.variables',
            'job-form.steps.variables-edit',
          ]).then(function (t) {
            $scope.clusterStep.title = t['job-form.steps.cluster'];
            $scope.clusterStep.activeTitle = t['job-form.steps.cluster-edit'];
            $scope.packageStep.title = t['job-form.steps.package'];
            $scope.packageStep.activeTitle = t['job-form.steps.package-edit'];
            $scope.packageVariablesStep.title = t['job-form.steps.variables'];
            $scope.packageVariablesStep.activeTitle = t['job-form.steps.variables-edit'];
          });

          const validateVariables = function () {
            $scope.variablesValid = $scope.packageVariablesStep.valid ? 1 : 100;
          };

          const getPackageIcon = function (_package) {
            const dataflowIcon =
              '<svg class="icon icons-master-expanded_icon-navmain-_packages"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#img-sprite_icons-master-expanded_icon-navmain-packages"></use></svg>';
            const workflowIcon =
              '<svg class="icon icons-master-expanded_icon-navmain-packages icon-workflow"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#img-sprite_icon-icons-master-expanded_icon-navmain-workflow"></use></svg>';
            return _package.flow_type === 'dataflow' ? dataflowIcon : workflowIcon;
          };

          const setPackageStep = function (_package) {
            if (_package && _package.id) {
              $scope.packageLoaded = false;
              $scope.job.package_id = parseInt(_package.id);
              $scope.packageVariablesStep.valid = true;
              $scope.packageVariablesStep.lock = false;
              $scope.packageStep.valid = true;
              const packageIcon = getPackageIcon(_package);
              $scope.packageStep.tags = [
                {
                  name: $sce.trustAsHtml(`${packageIcon} <b>${_.escape(_package.name)}</b>`),
                },
              ];
              $scope.variables = _package.variables;
              $scope.variablesToSet = angular.copy(_package.variables);

              $timeout(function () {
                $scope.packageLoaded = true;
              }, 1000);
              validateVariables();
            } else {
              $scope.job.package_id = null;
              $scope.packageStep.valid = false;
              $scope.packageStep.tags = [];
              $scope.packageVariablesStep.lock = true;
              $scope.packageVariablesStep.valid = false;
              $scope.variables = {};
              $scope.packageLoaded = false;
              validateVariables();
            }
          };

          $scope.onPackageChange = (packageItem) => {
            $scope.package = packageItem;
            $scope.package_id = packageItem.id;
            setPackageStep(packageItem);
          };

          const setClusterStep = function (cluster) {
            console.log('Cluster Step: ', cluster);
            if (cluster && cluster.id) {
              $scope.job.cluster_id = parseInt(cluster.id);
              $scope.clusterStep.valid = true;
              const clusterIcon =
                '<svg class="icon icons-master-expanded_icon-navmain-schedules"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#img-sprite_icons-master-expanded_icon-navmain-clusters"></use></svg>';
              $scope.clusterStep.tags = [
                {
                  name: $sce.trustAsHtml(`${clusterIcon} <b>${_.escape(cluster.name)}</b>`),
                },
              ];
            } else {
              $scope.job.cluster_id = null;
              $scope.clusterStep.valid = false;
              $scope.clusterStep.tags = [];
            }
          };

          $scope.onClusterChange = (cluster) => {
            $scope.cluster = cluster;
            $scope.cluster_id = cluster.id;
            setClusterStep(cluster);
          };

          const setVariablesStep = function (variables) {
            const tags = [];
            _.forIn(variables, function (value, key) {
              tags.push({
                name: `${_.escape(key)}: <b>${_.escape(value)}</b>`,
              });
            });
            $scope.packageVariablesStep.tags = tags;
            validateVariables();
          };

          $scope.$watch('package', setPackageStep, true);
          $scope.$watch('cluster', setClusterStep, true);
          $scope.$watch('variables', setVariablesStep, true);

          if ($scope.job.cluster_id && $scope.job.package_id) {
            $scope.packageVariablesStep.active = true;
          } else if ($scope.job.cluster_id) {
            $scope.packageStep.active = true;
          } else {
            $scope.clusterStep.active = true;
          }

          $scope.save = function () {
            const observableCall = Job.save(
              {
                cluster_id: $scope.job.cluster_id,
                package_id: $scope.job.package_id,
                dynamic_variables: $scope.variables,
              },
              {
                include: 'package,cluster',
              },
            ).pipe(shareReplay(1));
            observableCall.subscribe(
              function (newJob) {
                if ($state.current.name.indexOf('app.account.jobs') > -1) {
                  $rootScope.$broadcast(`${EVENTS.GENERIC_LIST_ADD_ITEM}jobs`, newJob);
                }
                $rootScope.$broadcast(EVENTS.MODAL_CLOSE);
                notify.jobSubmitted(newJob);
              },
              function () {
                notify.error(null, 'There was an issue while saving a job. Please try again.');
              },
            );
            return observableCall;
          };
        },
      ],
    };
  },
]);
